import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { I18nModule, PipesModule } from '@foxeet/utils-modules';
import { IonicModule } from '@ionic/angular';
import { FormValidationMessagesModule } from '../../form-validation-messages/mobile/form-validation-messages.module';
import { FormInputTextComponent } from './form-input-text.component';

@NgModule({
  declarations: [FormInputTextComponent],
  imports: [CommonModule, IonicModule, FormValidationMessagesModule, ReactiveFormsModule, I18nModule.forChild(), PipesModule],
  exports: [FormInputTextComponent],
})
export class FormInputTextModule {}
